<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">Combos</h4>
          <router-link to="/app/machines/combo">
            <l-button wide type="primary" round v-if="permission('create_combo')">
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>

          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div>
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()) ||
            data.sku.toLowerCase().includes(search.toLowerCase())  ||
            data.vm.toLowerCase().includes(search.toLowerCase())  ||
            data.price.toLowerCase().includes(search.toLowerCase()) )">
            <el-table-column label="SKU" property="sku" width="180" sortable/>
            <el-table-column label="Nome" property="name"  sortable/>
            <el-table-column label="Filial" property="company_name" v-if="showMatriz"/>
            <!-- <el-table-column label="VM" property="vm" min-width="250" sortable/> -->
            <!-- <el-table-column label="Preço (R$)" property="price" width="180" sortable/> -->
            <!-- <el-table-column label="VM" property="vm"></el-table-column> -->
            <el-table-column label="Ações" width="90">
              <div class="td-actions" slot-scope="props">
                <el-tooltip class="item" effect="dark" content="Editar" placement="top-start">
                  <a
                    v-if="permission('edit_combo')"
                    class="btn btn-warning btn-link btn-xs"
                    @click="handleEdit(props.$index, props.row)"
                  >
                    <i class="fa fa-edit"></i>
                  </a>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Deletar" placement="top-start">
                  <a
                    v-if="permission('delete_combo')"
                    class="btn btn-danger btn-link btn-xs"
                    @click="handleDelete(props.$index, props.row)"
                  >
                    <i class="fa fa-close"></i>
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Tooltip } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      search: '' 
    };
  },
  computed: {
    tableData() {
      // const machines = this.$store.state.machines.machines
      const combos = this.$store.state.combos.combos
      const populated = combos.map(v =>{
        // var vm = ''
        // if (v.vm) {
        //   vm = machines.find(e => e.id == v.vm);
        //   vm = vm.location
        // }
        return { ...v };
      })
      console.log('pop', populated)
      return populated
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },    
  },
  created() {
    // this.$store.dispatch("machines/list").then(()=> {
    const ciaID = localStorage.getItem('imachCiaID')
    if (ciaID) {
      this.$store.dispatch("combos/listSort", {sort: '?company=' + ciaID}).catch(err => console.log(err))

    } else {
      this.$store.dispatch("combos/list").catch(err => console.log(err))
    }
    // }).catch(err => console.log(err))
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  mounted () {
    this.getListCompany()
  },
  methods: {
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/combo/${row.id}`);
    },
    getListCompany () {
      this.$store.dispatch("company/list")
    },
    permission (permissao) {
      var x = this.$store.state.general.permission.permissoes_do_usuario.filter(el => {
        if (el == permissao) {
          return true
        } 
      })
      if (x.length > 0) {
        return true
      }
      if (this.showMatriz) {
        return true
      }
    },
    handleDelete(i, row) {
      console.log(row);
      const itemName = "Produto";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("combos/delete", { id: row.id });
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
.card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
}
</style>
